import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { dateFormat, formatToCompanyTimezone } from "../../../../lib/functions";
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");

const CreditorPaymentRecordTable = ({ printMode = false }) => {
  const { list, loading, filters } = useSelector((state) => state.creditorPaymentRecord);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  // Columns for without details view
  const withoutDetailsColumns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "VCH No", dataIndex: "pay_code" },
    { title: "Date", dataIndex: "created_date", render: (v) => v ? formatToCompanyTimezone(v).split(" ")[0] : "-", },
    { title: "Creditor/Supplier", dataIndex: "acc_name" },
    { title: "Payment By", dataIndex: "full_name" },
    {
      title: "Total Amount",
      dataIndex: "pay_total",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
    },
  ];

  // Columns for with details view
  const withDetailsColumns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "VCH", dataIndex: "pay_code" },
    { title: "Date", dataIndex: "created_date", render: (date, record) =>
    record.isSubtotal ? "" : formatToCompanyTimezone(date).split(" ")[0], },
    { title: "Creditor/Supplier", dataIndex: "acc_name"},
    { title: "Payment By", dataIndex: "full_name" },
    { title: "Payment From", dataIndex: "from_acc_name", render: (_, r) => r.isSubtotal ? <strong>Sub Total</strong> : r.from_acc_name  },
    {
      title: "Payment Amount",
      dataIndex: "pay_total",
      align: "right",
    render: (val, r) =>
      r.isSubtotal
        ? <strong>{format((r.subtotal || 0).toFixed(2))}</strong>
        : format(parseFloat(val || 0).toFixed(2))
  }
  ];

  // Calculate grand totals
  const totals = list.reduce(
  (acc, row) => {
    if (!row.isSubtotal) {
      acc.total += Number(row.pay_total || 0);
    }
    return acc;
  },
  { total: 0 }
);


  const columns = filters.recordType === "with details" ? withDetailsColumns : withoutDetailsColumns;
  const colSpan = filters.recordType === "with details" ? 6 : 5;

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      scroll={printMode ? undefined : { x: 'max-content' }}
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={colSpan} align="right">
            <strong>Grand Total: &nbsp; &nbsp; &nbsp;</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={1} align="right">
            <strong>{format(totals.total.toFixed(2))}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default CreditorPaymentRecordTable;